import { oc } from '@orpc/contract';
import { idParamSchema } from '../../common/schemas/id.schemas.js';
import { vehicleDetailSchema } from '../schemas/vehicles.schemas.js';
export const getVehicleContract = oc
    .route({
    method: 'GET',
    path: '/vehicles/{id}',
    tags: ['Vehicles'],
    summary: 'Full vehicle specification including its published reference figures',
})
    .input(idParamSchema)
    .output(vehicleDetailSchema);
//# sourceMappingURL=get-vehicle.contract.js.map